/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/8/22
 */

import React from "react";
import { Stack, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { addDays, isAfter, isBefore } from "date-fns";

export interface DateRangePickerProps {
	range: Interval
	onChange: (range: Interval) => void
	startDateLabel?: string
	endDateLabel?: string
}

export default function DateRangePicker({ range, onChange, startDateLabel, endDateLabel }: DateRangePickerProps) {

	const submit = (range: Interval) => {
		if (range.end < range.start) {
			onChange({ start: addDays(range.end, -7).getTime(), end: new Date(range.end).getTime() });
		} else {
			onChange({ start: new Date(range.start).getTime(), end: new Date(range.end).getTime() });
		}
	}

	return (
		<Stack direction={"row"} spacing={2}>
			<DatePicker
				label={startDateLabel ?? "From"}
				value={range.start}
				onChange={(value) => {
					if (value && value instanceof Date && isBefore(value, range.end)) {
						submit({ start: value, end: range.end });
					}
				}}
				renderInput={(params) =>
					<TextField
						sx={{ width: "140px" }}
						variant={"standard"}
						{...params}
					/>
				}
			/>
			<DatePicker
				label={endDateLabel ?? "To"}
				value={range.end}
				onChange={(value) => {
					if (value && value instanceof Date && isAfter(value, range.start)) {
						submit({ start: range.start, end: value });
					}
				}}
				renderInput={(params) =>
					<TextField
						sx={{ width: "140px" }}
						variant={"standard"}
						{...params}
					/>
				}
			/>
		</Stack>
	);

}